import { useCallback, useMemo } from 'react';

import { useEmployerReactivationModalStore } from '@/modules/employer/components/EmployerReactivation/stores';
import { BankInfo } from '@/modules/employer/components/SetupEmployer/SetupEmployer.types';

import useEmployerReactivationBankListQuery from './useEmployerReactivationBankList.query';

interface Props {
  onEdit?: () => void;
  onView?: () => void;
  setBank?: (bank: BankInfo) => void;
}

const useEmployerReactivationBankList = (props: Props) => {
  const employerId = useEmployerReactivationModalStore((state) => state.employerId);

  const { banks, isLoading, isFetched, options } = useEmployerReactivationBankListQuery(employerId);

  const findBankById = useCallback(
    (id: string) => banks.find((item) => item.id === id),
    [banks],
  );

  const onEditHandler = useCallback((bankId: string) => {
    const bank = findBankById(bankId);
    if (bank) {
      props?.setBank?.(bank as BankInfo);
      props?.onEdit?.();
    }
  }, [findBankById, props]);

  const onViewHandler = useCallback((bankId: string) => {
    const bank = findBankById(bankId);
    if (bank) {
      props?.setBank?.(bank as BankInfo);
      props?.onView?.();
    }
  }, [findBankById, props]);
  
  const isEmpty = useMemo(() => banks?.length === 0, [banks]);
  
  return {
    banks,
    isLoading,
    isFetched,
    isEmpty,
    onEditHandler,
    onViewHandler,
    options,
  };
};

export default useEmployerReactivationBankList;
